<template>
  <div v-if="show && advisory.body" id="advisory" class="modal fade in" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg">
      <div class="modal-content pad-15 advisory-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" @click="show = false">&times;</button>
          <h3 class="modal-title">{{ advisory.title }}</h3>
        </div>
        <div class="modal-body">
          <div v-html="advisory.body"></div>
          <hr />
          <div class="row pad-5">
            <div class="col-xs-6 inline-el">
              <span class="form-label">Do not show this message again?</span>
              <div class="material-switch">
                <input id="add-st" type="checkbox" v-model="doNotShowAgain"/>
                <label for="add-st" class="label-warning"></label>
              </div>
            </div>
            <div class="col-xs-6 pull-right">
              <button class="btn btn-default sq pull-right" @click="show = false">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Advisory',
  props: {
    advisory: {
      type: Object,
      required: true
    }
  },
  watch: {
    doNotShowAgain (newVal) {
      const showOrHide = newVal ? 'HIDE' : 'SHOW'
      this.updateUserAdvisorySetting(showOrHide)
    }
  },
  data () {
    return {
      show: true,
      doNotShowAgain: false
    }
  },
  methods: {
    updateUserAdvisorySetting (showOrHide) {
      const maiUser = this.$store.getters['authentication/userId']
      const body = { setting: showOrHide, maiUser }
      this.$store.dispatch('library/updateUserAdvisorySetting', body).catch(console.log)
    }
  }
}
</script>
<style scoped>
  .advisory-content {
    max-height: calc(100vh - 40px);
    overflow: scroll;
  }
  .inline-el {
    display: flex;
    color: #818181;
  }
  .inline-el span {
    padding-top: 5px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// Advisory.vue?2bfb4585